import { render, staticRenderFns } from "./CollectionPerformance.vue?vue&type=template&id=80018a8e&scoped=true"
import script from "./CollectionPerformance.vue?vue&type=script&lang=js"
export * from "./CollectionPerformance.vue?vue&type=script&lang=js"
import style0 from "./CollectionPerformance.vue?vue&type=style&index=0&id=80018a8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80018a8e",
  null
  
)

export default component.exports